//const API_BASE_URL = 'http://api-contable.netappperu.net/api';
const API_BASE_URL = 'http://api-napcontable.netappperu.net/api';
//const API_BASE_URL = 'http://3.137.142.138/api';
// const API_BASE_URL = 'http://api-contable.com/api';
export { API_BASE_URL };
